"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledLoader = styled_components_1.default.div `
  display: inline-block;
  position: relative;

  left: calc(50% - 40px);
  top: calc(50% - 40px);
  width: 20px;
  height: 20px;

  & div {
    transform-origin: 40px 40px;
    animation: lds-spinner 0.8s linear infinite;
  }
  & div:after {
    content: " ";
    display: block;
    position: absolute;
    top: 32px;
    left: 40px;
    width: 2px;
    height: 4px;
    border-radius: 35%;
    background: ${({ variant, isDanger, isDisabled, theme }) => {
    if (isDisabled)
        return theme.neutral.main;
    switch (variant) {
        case "contained": {
            return theme.white;
        }
        case "outlined":
        case "text": {
            if (isDanger)
                return theme.error.main;
            return theme.primary.main;
        }
    }
}};
    transform: translateX(-50%);
  }
  & div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
  }
  & div:nth-child(2) {
    transform: rotate(45deg);
    animation-delay: -1s;
  }
  & div:nth-child(3) {
    transform: rotate(90deg);
    animation-delay: -0.9s;
  }
  & div:nth-child(4) {
    transform: rotate(135deg);
    animation-delay: -0.8s;
  }
  & div:nth-child(5) {
    transform: rotate(180deg);
    animation-delay: -0.7s;
  }
  & div:nth-child(6) {
    transform: rotate(225deg);
    animation-delay: -0.6s;
  }
  & div:nth-child(7) {
    transform: rotate(270deg);
    animation-delay: -0.5s;
  }
  & div:nth-child(8) {
    transform: rotate(315deg);
    animation-delay: -0.4s;
  }

  @keyframes lds-spinner {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;
const StyledFullHeight = styled_components_1.default.span `
  display: flex;
  justify-content: center;
  margin-left: -5px;
`;
const StyledWrapSpinner = styled_components_1.default.span `
  display: flex;
  justify-content: center;
`;
const LoadSpinner = ({ variant, isDanger, isDisabled }) => {
    return (react_1.default.createElement(StyledWrapSpinner, null,
        react_1.default.createElement(StyledFullHeight, null,
            react_1.default.createElement(StyledLoader, { variant: variant, isDanger: isDanger, isDisabled: isDisabled },
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", null)))));
};
const Loader = ({ variant, isDanger, isDisabled }) => (react_1.default.createElement("div", { style: {
        display: "flex",
        justifyContent: "center",
        marginTop: "-1px",
        alignItems: "center"
    } },
    react_1.default.createElement(LoadSpinner, { variant: variant, isDanger: isDanger, isDisabled: isDisabled }),
    react_1.default.createElement("div", { style: { width: "7px", height: "7px" } }),
    " Loading"));
exports.Loader = Loader;
